module.exports = __webpack_public_path__ + "static/45e772ce-a542-41fa-b36e-d4e4a6b268d0-160.d1e77537.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/st-michael-and-all-angels/45e772ce-a542-41fa-b36e-d4e4a6b268d0-160.jpg
// module id = 1142
// module chunks = 168707334958949